<template>
  <div class="competitionRight">
    <section class="wrap" style="display:none;">
      <div class="head-wrap">
        <div class="head-line"></div>
        <h1 class="head">{{$t('global.举办方简介')}}</h1>
      </div>
      <router-link
        tag="div"
        :to="'/peopleCenter/'+data.userId"
        class="name-wrap"
      >
        <img
          :src="data.avatar | imageUrl('/static/profile_img_default.png',40,40)"
          alt=""
        >
        <strong class="name">{{ data.nickname }}</strong>
        <div
          class="icon-official"
          v-if="data.userId == 233"
        ></div>
      </router-link>
    </section>
    <section class="wrap">
      <div class="head-wrap">
        <div class="head-line"></div>
        <h1 class="head">{{$t('global.时间')}}</h1>
      </div>
      <p class="time">{{$t('global.报名时间')}}：{{dateFormatter(data.registrationTimeStart)}} {{$t('global.至')}} {{dateFormatter(data.registrationTimeEnd)}}</p>
      <p class="time">{{$t('global.举办时间')}}：{{dateFormatter(data.holdingTimeStart)}} {{$t('global.至')}} {{dateFormatter(data.holdingTimeEnd)}}</p>
    </section>
  </div>
</template>

<script>
import tools from "@/util/tools";

export default {
  props: {
    data: {
      id: Number,
      thumb: "",
      title: "",
      isOfficial: true,
      info: "",
      nickname: "",
      introduce: "",
      userId: "",
      avatar: "",
      registrationTimeStart: Date,
      registrationTimeEnd: Date,
      holdingTimeStart: Date,
      holdingTimeEnd: Date
    }
  },
  computed: {
    localTime() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    }
  },
  data() {
    return {
      isHidden: true,
      isShown: false
    };
  },

  methods: {
    dateFormatter: tools.dateFormatter,
    foldText: tools.autoHideText,
    toggleFold: function() {
      this.isHidden = !this.isHidden;
    },

    signUp() {
      this.$router.push(`/activityMatch/${this.data.id}/signUp`);
    },

    upload() {
      // TODO need api support
    }
  }
};
</script>

<style lang="stylus" scoped>
.competitionRight {
  width: 383px;
  margin-left: 20px;
  border 1px solid #eee
  box-shadow 0 0 20px 0 #eee
  border-radius 14px

  .wrap {
    background-color: #fff;
    padding: 0.39rem 0;
    margin-bottom: 0.2rem;

    .time {
      color: #999;
      font-size: 14px;
      padding: 0.3rem 0 0 0.27rem;
    }

    .brif-wrap {
      position: relative;
      font-size: 0.16rem;
      color: #777777;
      padding: 0.2rem 0.26rem 0;
    }

    .info {
      padding-bottom: 0.2rem;
    }

    .unfold {
      position: absolute;
      right: 0.26rem;
      bottom: 0;
      padding: 0;
      font-size: 0.2rem;
      color: #0060ff;
    }

    .name-wrap {
      display: flex;
      align-items: center;
      margin-top: 0.5rem;

      img {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        margin-left: 0.4rem;
        cursor: pointer;
        border-radius: 50%;
      }

      .name {
        display: inline-block;
        max-width: 1.7rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.2rem;
        color: #333333;
        margin-left: 0.3rem;
        cursor: pointer;
      }

      .icon-official {
        width: 0.24rem;
        height: 0.24rem;
        margin-left: 0.1rem;
        background: url('/static/specialCompetitiom/guan.png') no-repeat;
        background-size: cover;
      }
    }

    .head-wrap {
      display: flex;
      align-items: center;

      .head-line {
        width: 0.06rem;
        height: 0.19rem;
        background-color: #0161ff;
        border-radius: 0.03rem;
      }

      .head {
        color: #333333;
        margin-left: 0.2rem;
        font-size: 18px;
      }
    }
  }

  .upload {
    color: #fff;
    font-size: 0.26rem;
    background-color: #0161ff;
    border-radius: 0.08rem;
    width: 100%;
    height: 1rem;
    margin-bottom: 0.2rem;
  }

  .uploaddis {
    color: #fff;
    font-size: 0.26rem;
    background-color: #777;
    border-radius: 0.08rem;
    width: 100%;
    height: 1rem;
    margin-bottom: 0.2rem;
  }

  .arrow {
    animation: rotate 1s ease forwards;
  }

  .arrow-reverse {
    animation: rotate-reverse 1s ease forwards;
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(180deg);
    }
  }

  @keyframes rotate-reverse {
    from {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/RightAside.vue